module.exports = __webpack_public_path__ + "static/media/kerry-blue.29da9f21.png";